<template>
    <div class="manager_dashboard">
        <user-menu />
        <div class="wrapper">
            <EnterpriseAdminSidebarMenu :show_menu="false" :show_back_button="true" back_link="enterpriseadminreports"/>
            <div class="content-wrapper"  style="padding-left: 165px !important;">
                <div class="container-wrapper center ml-2">
                  <div class="modal-custom" v-show="showOverlay">
                    <div class="loader-img-center">
                      <i class="fa fa-spinner fa-spin"></i> Please wait...
                    </div>
                  </div>
                    <div class="rep_audit_bg">
                        <div class="col-12 ">
                            <h3 class="rep_heading pb-1 border-bottom text-uppercase">Rep Audit Trail</h3>
                        </div>

          <div class="row top-content"  v-if="loading == true">
          <div class="col-3 p-0 pl-4">
            <PuSkeleton height="30px" :count="1"></PuSkeleton>
          </div>
          <div class="col-3 text-right p-0 pl-3">
            <PuSkeleton height="30px" :count="1"></PuSkeleton>
          </div>
          <div class="col-3 text-right p-0 pl-3">
            <PuSkeleton height="30px" :count="1"></PuSkeleton>
          </div>
          <div class="col-3 text-right p-0 pl-3 pr-3">
            <PuSkeleton  height="30px" :count="1"></PuSkeleton>
          </div>
          </div>



                        <div class="row"  v-if="loading == false">
                            <div class="col p-0">
                                <div class="row col-12">
                                    <div class="col-12 col-xl-3 pl-4">
                                        <div class="cp-filter-label col-5 float-left" style="width: 32%; margin-top: 20px;">Location:</div>
                                        <b-form-select v-model="accountId" :options="report_all_locations" style="margin-bottom: 10px !important; margin-top: 12px;" class="col-7 float-left" @change="updateAccountAction()" />
                                    </div>

                                    <div class="col-12 col-xl-3">
                                        <div class="cp-filter-label col-4 float-left" style="width: 29%; margin-top: 20px;">User:</div>
                                        <b-form-select v-model="rep_mentee" :options="menteeLists" style="margin-bottom: 10px !important; margin-top: 12px;" class="col-7 float-left" @change="filterCompetency()" />
                                    </div>
                                    <div class="col-12 col-xl-4">
                                        <div class="col-7 p-0 float-left">
                                        <div class="cp-filter-label col-5 float-left" style="width: 37%; margin-top: 20px;">Date Range:</div>
                                        <b-form-select v-model="rep_days" :options="itemSource2" style="width: 57%; margin-bottom: 10px !important; margin-top: 12px;" class="col-7 float-left" @change="filterCompetency()" />
                                        </div>
                                        <div class="col-5 p-0 float-left mt-3" >
                                        <div class="col-2 float-left p-0 custom-checkbox">
                                          <input 
                                            name="show_comments"
                                            value="1" 
                                            id="show_comments_checkbox"
                                            type="checkbox"
                                            class="custom-control-input mt-2 ml-1"
                                            v-model="show_comments"
                                            @click="changeShowComments($event)"
                                            >
                                          <label for="show_comments_checkbox" class="custom-control-label ml-4 mt-2" style="margin-left: 30px !important"></label>
                                          
                                        </div>
                                        <div class="col-10 float-left p-0 bold mt-2">Show Comments</div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-2  pr-0 float-right text-right mt-4">

                                        <div class="margin-t-2 float-right pl-2" >
                                        <div v-if="results.length > 0" class="" @click="shareButtonModal()"><img class="cursor-pointer" src="@/assets/Send_Report_Button.svg" alt="MentorMentee" width="24px"  /></div></div>

                                        <div class="margin-t-2 float-right pl-2 mr-2" @click="exportCSVAction()" ><img v-if="results.length > 0"  class="cursor-pointer" src="@/assets/Download_Report.svg" alt="MentorMentee" width="24px"  /></div>

                                        <button type="button" class="btn ma-blue-btn filter-btn btn-md" @click="filterCompetency()"  >Filter</button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="clear"></div>
                    <div class="rep_audit_bg"  >

                        <div class="row report_heading pr-3 pl-4" v-if="show_comments == true">
                           <div class="field_1"
                            v-on:click="sortMethod('submitted')">
                                Submitted
                                <i v-if="sortField == 'submitted' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'submitted' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>
                            <div v-if="accountId == 'All'" class="field_2_1" v-on:click="sortMethod('description')">
                                Task
                                <i v-if="sortField == 'description' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'description' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>
                            <div v-else class="field_2_2" v-on:click="sortMethod('description')">
                                Task
                                <i v-if="sortField == 'description' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'description' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>

                            <div v-if="accountId == 'All'" class="field_3_1" v-on:click="sortMethod('tasklist_name')">
                                Skill Sets
                                <i v-if="sortField == 'tasklist_name' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'tasklist_name' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>
                            <div v-else class="field_3_2" v-on:click="sortMethod('tasklist_name')">
                                Skill Sets
                                <i v-if="sortField == 'tasklist_name' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'tasklist_name' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>

                            <div v-if="accountId == 'All'" class="field_4_1" v-on:click="sortMethod('mentee_name')">
                                {{ menteeTitle }}
                                <i v-if="sortField == 'mentee_name' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'mentee_name' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>
                            <div v-else class="field_4_2" v-on:click="sortMethod('mentee_name')">
                                {{ menteeTitle }}
                                <i v-if="sortField == 'mentee_name' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'mentee_name' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>


                            <div class="field_5" v-on:click="sortMethod('mentor_name')">
                                Approved by
                                <i v-if="sortField == 'mentor_name' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'mentor_name' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>

                            <div v-if="accountId == 'All'"  class="field_6_1" v-on:click="sortMethod('timeOnTask')">
                                Time
                                <i v-if="sortField == 'timeOnTask' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'timeOnTask' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>
                            <div v-else class="field_6_2" v-on:click="sortMethod('timeOnTask')">
                                Time
                                <i v-if="sortField == 'timeOnTask' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'timeOnTask' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>


                            <div v-if="accountId == 'All'" class="field_7_1" v-on:click="sortMethod('score')">
                                Rating
                                <i v-if="sortField == 'score' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'score' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>
                            <div v-else class="field_7_2" v-on:click="sortMethod('score')">
                                Rating
                                <i v-if="sortField == 'score' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'score' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>

                            <div class="field_8_1" v-on:click="sortMethod('createdAt')">
                                Approved
                                <i v-if="sortField == 'createdAt' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'createdAt' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>

                            <div v-if="accountId == 'All'"  class="field_9_1" v-on:click="sortMethod('companyName')">
                                Location
                                <i v-if="sortField == 'companyName' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'companyName' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>
                            <div class="field_10">
                                Comment
                            </div>

                            <div class="col-12 padding-lr-5" >
                                <div class="custom_heading_hr"></div>
                            </div>
                        </div>

                        <div class="row report_heading  pr-3 pl-4" v-else>
                           <div class="field_1" 
                            v-on:click="sortMethod('submitted')">
                                Submitted
                                <i v-if="sortField == 'submitted' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'submitted' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>
                            <div v-if="accountId == 'All'" class="field_2_1" v-on:click="sortMethod('description')">
                                Task
                                <i v-if="sortField == 'description' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'description' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>
                            <div v-else class="field_2_2" v-on:click="sortMethod('description')">
                                Task
                                <i v-if="sortField == 'description' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'description' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>

                            <div v-if="accountId == 'All'" class="field_3_3" v-on:click="sortMethod('tasklist_name')">
                                Skill Sets
                                <i v-if="sortField == 'tasklist_name' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'tasklist_name' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>
                            <div v-else class="field_3_4" v-on:click="sortMethod('tasklist_name')">
                                Skill Sets
                                <i v-if="sortField == 'tasklist_name' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'tasklist_name' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>

                            <div v-if="accountId == 'All'" class="field_4_1" v-on:click="sortMethod('mentee_name')">
                                {{ menteeTitle }}
                                <i v-if="sortField == 'mentee_name' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'mentee_name' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>
                            <div v-else class="field_4_2" v-on:click="sortMethod('mentee_name')">
                                {{ menteeTitle }}
                                <i v-if="sortField == 'mentee_name' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'mentee_name' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>


                            <div class="field_5" v-on:click="sortMethod('mentor_name')">
                                Approved by
                                <i v-if="sortField == 'mentor_name' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'mentor_name' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>

                            <div v-if="accountId == 'All'"  class="field_6_2" v-on:click="sortMethod('timeOnTask')">
                                Time
                                <i v-if="sortField == 'timeOnTask' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'timeOnTask' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>
                            <div v-else class="field_6_3" v-on:click="sortMethod('timeOnTask')">
                                Time
                                <i v-if="sortField == 'timeOnTask' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'timeOnTask' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>


                            <div v-if="accountId == 'All'" class="field_7_1" v-on:click="sortMethod('score')">
                                Rating
                                <i v-if="sortField == 'score' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'score' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>
                            <div v-else class="field_7_2" v-on:click="sortMethod('score')">
                                Rating
                                <i v-if="sortField == 'score' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'score' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>

                            <div class="field_8_2" v-on:click="sortMethod('createdAt')">
                                Approved
                                <i v-if="sortField == 'createdAt' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'createdAt' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>

                            <div v-if="accountId == 'All'" class="field_9_2" v-on:click="sortMethod('companyName')">
                                Location
                                <i v-if="sortField == 'companyName' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                <i v-if="sortField == 'companyName' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                            </div>

                            <div class="col-12 padding-lr-5" >
                                <div class="custom_heading_hr"></div>
                            </div>
                        </div>



          <div class="text-center pt-4" v-if="loading == true">
            <div class="row ml-3" v-for="option in 5">
              <div class="field_1 p-0"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="field_4_1"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="field_4_1"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="field_4_1" ><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="field_4_1" ><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="field_6_2"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="field_7_1"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="field_4_1"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="field_9_2"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="col-12 p-0">
                <div class="custom_hr"></div>
              </div>
            </div>
          </div>




                        <div class="col-12 p-0  pr-3 pl-4" v-if="results.length > 0">
                        <div class="view-accountlist">
                        <div v-if="show_comments == true">
                        <div class="row report_view" v-for="(result,index) in results" >
                            <div class="field_1"
                            >
                            {{ result.submittedDate }}
                            </div>

                            <div v-if="accountId == 'All'" class=" txt_break field_2_1">{{ result.description }}</div>
                            <div v-else class="field_2_2 txt_break" >{{ result.description }}</div>

                            <div v-if="accountId == 'All'" class="field_3_1 txt_break">{{ result.tasklist_name }}</div>
                            <div v-else class="field_3_2 txt_break" >{{ result.tasklist_name }}</div>

                            <div v-if="accountId == 'All'" class="field_4_1 txt_break">{{ result.mentee_name }}</div>
                            <div v-else class="field_4_2 txt_break" >{{ result.mentee_name }}</div>

                            <div class="field_5 txt_break" >{{ result.mentor_name }}</div>

                            <div v-if="accountId == 'All'" class="field_6_1">{{ result.timeOnTask }}</div>
                            <div v-else class="field_6_2" >{{ result.timeOnTask }}</div>

                            <div class="field_7_1" v-if="result.score != 0 && accountId == 'All'">{{ result.score }}</div>
                            <div class="field_7_2"  v-else-if="result.score != 0 && accountId != 'All'">{{ result.score }}</div>
                            <div class="field_7_1" v-else-if="accountId == 'All'"></div>
                            <div class="field_7_2" v-else></div>
                            <div class="field_8_1" >{{ result.updatedDate }}</div>
                            <div v-if="accountId == 'All'" class="field_9_1 txt_break">{{ result.companyName }}</div>
                            <div class="field_10 txt_break" v-if="show_comments == true && result.score != 'Skill Pass'">
                                <b>{{ result.mentee_name }}.-</b> {{ result.menteeComment }}<br/>
                                <b>{{ result.mentor_name }}.-</b> {{ result.comment }}
                            </div>
                            <div class="col-12 padding-lr-5">
                                <div class="custom_hr"></div>
                            </div>
                        </div>
                        </div>
                        <div v-else>
                        <div class="row report_view " v-for="(result,index) in results" >
                            <div class="field_1"
                            >
                            {{ result.submittedDate }}
                            </div>

                            <div v-if="accountId == 'All'" class="field_2_1 txt_break">{{ result.description }}</div>
                            <div v-else class="field_2_2 txt_break" >{{ result.description }}</div>

                            <div v-if="accountId == 'All'" class="field_3_3 txt_break">{{ result.tasklist_name }}</div>
                            <div v-else class="field_3_4 txt_break" >{{ result.tasklist_name }}</div>

                            <div v-if="accountId == 'All'" class="field_4_1 txt_break">{{ result.mentee_name }}</div>
                            <div v-else class="field_4_2 txt_break">{{ result.mentee_name }}</div>

                            <div class="field_5 txt_break" >{{ result.mentor_name }}</div>

                            <div v-if="accountId == 'All'" class="field_6_2">{{ result.timeOnTask }}</div>
                            <div v-else class="field_6_3" >{{ result.timeOnTask }}</div>

                            <div class="field_7_1"  v-if="result.score != 0 && accountId == 'All'">{{ result.score }}</div>
                            <div class="field_7_2"  v-else-if="result.score != 0 && accountId != 'All'">{{ result.score }}</div>
                            <div class="field_7_1"  v-else-if="accountId == 'All'"></div>
                            <div class="field_7_2" v-else></div>
                            <div class="field_8_2">{{ result.updatedDate }}</div>
                            <div v-if="accountId == 'All'" class=" txt_break field_9_2">{{ result.companyName }}</div>
                            <div class="col-12 padding-lr-5">
                                <div class="custom_hr"></div>
                            </div>
                        </div>
                        </div>

                    </div>
                    <div class="clear"></div>
                    <div class="col-12 float-left override-padding pagination-wrapper" >
                     <Pagination
                     ref="Pagination"
                     :currentPage="currentPage"
                     :totalRows="rows"
                     :perPage="perPage"
                     :showPaginatedFunction="showNaicsofPaginated"
                     :showPerPageFunction="perPagePaginated"
                     :totalPages="totalPages"
                     :sNo="sno"
                     >
                     </Pagination>
                    </div>
                 </div>
                 <div class="col-12 p-0  pr-3 pl-4 text-center"  v-else-if="loading == false">
                      No records found.
                 </div>

                    </div>
                </div>
            </div>
        </div>
        
        <EnterpriseAdminOverlaySidebar
              :isModalVisible="isModalVisible" 
              @close="closeSidebar"
              ref="location_sidebar" 
              :readOnly="isReadOnly" 
             />


      <BatchModal :isModalVisible="isExportModalVisible" @close="isExportModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading"></div>
        <div slot="body">
          <div class="">
            <div class="export-details">
              Exported: {{ rowsExportedCSV }} of {{ rowsCSV}}
            </div>
            <div class="percentage-text">
              {{ percentage }}
            </div>
            <div class="batch-box">
              <div class="batch-loading" id="batch-loading" >
                &nbsp;
              </div>
            </div>
            <div class="download-link" @click="downloadFunc()" v-if="percentage == '100%'">
              Download CSV File
            </div>
          </div>
        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </BatchModal>

    <ShareReportModal :isModalVisible="isShareModalVisible" @close="isShareModalVisible = false, share_email = ''">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Share Report</h3></div>
      <div slot="body">
        <div v-if="showShareSuccess == true" class="col-12 override-padding success_msg">
          <b>Report shared successfully!</b>
        </div>
        <div class="col-12 override-padding">
          <input v-model="share_email"
                name="share_email"
                placeholder="Enter Email..."
                class="col-lg-12 input-text form-control input-height-35"
                
                v-validate="'required|email'"
                @keyup="checkEmail()"
                data-vv-as="Email address"
                maxlength="255" />
         <div v-show="verrors.has('share_email')" class="validate-warning-msg">{{ verrors.first('share_email') }}</div>
        </div>
        <div class="clear margin-bottom-10"></div>


        <div v-if="showWait == false" class="col-12 override-padding text-align-right">
          <button
              :disabled="share_button_disable"
              v-on:click="shareButtonSubmit()"
              class="btn btn-red col-3 input-height-25 createBtn"
              ><b>{{ submit_text }}</b></button>
        </div>
        <div v-if="showWait == true" class="col-12 override-padding text-align-right">
          <button
              disabled="true"
              class="btn btn-dard-grey col-lg-3"
              ><b>Please wait...</b></button>
        </div>

      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </ShareReportModal>



    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import router from '../../router/index.js';
import store from '../../store/store.js';
import moment from 'moment';
import EnterpriseAdminSidebarMenu from '../shared/enterpriseadmin_sidebar_menu.vue';
import EnterpriseAdminOverlaySidebar from './enterpriseadmin_overlay_sidebar.vue';
import VeeValidate from 'vee-validate';
import Pagination from '../pagination.vue';
import BatchModal from '../admin/reports/report_loading_modal.vue';
import ShareReportModal from '../admin/create-tasklist-modal.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

Vue.filter('formatDate', function(value) {
   if (value) {
     return moment(String(value)).format('MMM DD, YYYY')
   }
});

export default {
    data() {
        return {
            loading: false,
            results: [],
            items: [],
            items2: [],
            taskLists: [],	
            rep_tasklist: '',
            rep_days: '',
            menteeStr: '',
            menteeLists: [{ value: "", text: "Select Mentee" }, ],
            rep_mentee: '',
            rep_task_list: '',
            itemSource2: [
                { value: "", text: "Select Date Range" }, 
                { value: "7", text: "Last 7 days" }, 
                { value: "15", text: "Last 15 days" },
                { value: "30", text: "Last 30 days" },
                { value: "180", text: "Last 6 Months" },
                { value: "All", text: "All Time" }
            ],
            report_all_locations: [],
            accountId: '',
            isModalVisible: false,
            accountItems: [],
            rep_days: 30,
            sortField: '',
            sortBy: 'ASC',
            isExportModalVisible: false,
            percentage: '0%',
            fileName: '',
            totalCSVPages: 0,
            perCSVPage: 100,
            rowsCSV: 0,
            rowsExportedCSV: 0,
            currentCSVPage: 1,
            apiUrl: '',
            showWait: false,
            showShareSuccess: false,
            isShareModalVisible: false,
            submit_text: 'Submit',
            share_email: '',
            share_button_disable: true,
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pageOptions: [],
            totalPages: 0,
            sno: 0,
            menteeTitle: 'Mentee/Apprentice',
            showOverlay: false,
            show_comments: false,
        }
    },
    components: {
        UserMenu,
        GoBack,
        EnterpriseAdminSidebarMenu,
        EnterpriseAdminOverlaySidebar,
        Pagination,
        BatchModal,
        ShareReportModal,
    },
    computed: {
      isReadOnly(){
        if (this.$store.state.enterprise_type === 'Readonly') {
          return true;
        } else {
          if (this.$store.state.switch_admin_enterprise_isreadonly) {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    methods: {
        navigate(path) {
            router.push(path);
        },
        changeShowComments(event) {
            if(event.target.checked == true) {
                this.show_comments = true;
            }
            else {
                this.show_comments = false;
            }
        },
        checkEmail: function() {
            if ((this.verrors.items.length === 0)) {
                this.share_button_disable = false;
            }
            else {
                this.share_button_disable = true;
            }
        },
        updateAccountAction() {
          this.getAccountMenteesList();
        },
        shareButtonModal() {
          this.isShareModalVisible = true;
          this.verrors.clear();
        },
        shareButtonSubmit: function() {
          this.$validator.validateAll().then((result) => {
            if ((this.verrors.items.length === 0)) {
                this.submit_text = 'Please wait...';
                this.showWait = true;
                this.currentCSVPage = 1;
                this.rowsCSV = 0;
                this.rowsExportedCSV = 0;
                this.totalCSVPages = 0;
                this.percentage = 0;
                this.fileName = '';

                const params = {};
                if (this.accountId) {
                    params.accountId = this.accountId
                }
                if (this.rep_mentee) {
                    params.mentee = this.rep_mentee
                }
                if (this.rep_days) {
                    params.days = this.rep_days;
                } else {
                    params.days = '';
                }
                if (this.sortField) {
                    params.sortfield = this.sortField
                }
                if (this.sortBy) {
                    params.sortby = this.sortBy
                }
                params.page = this.currentCSVPage;
                params.perPage = this.perCSVPage;
                params.fileName = this.fileName;
                params.email = this.share_email;
                params.show_comments = this.show_comments;

                axios.get('/enterprise-admin/account_mentee_ratings_report_share_csv', {
                    params: params
                })
                .then(response => {
                    this.share_email = '';
                    this.submit_text = 'Submit';
                    this.share_button_disable = true;
                    this.showWait = false;
                    this.showShareSuccess = true;
                    setTimeout(() => {
                        this.showShareSuccess = false;
                    }, 5000)
                })
                .catch(error => {

                });
            }
          });

        },

        downloadFunc: function() {
              var url = this.apiUrl + '/custom/csv-view/' + this.fileName + '/Rep-Audit';
              window.location.href = url;
              this.isExportModalVisible = false;
              return false;
        },
          exportCSVAction: function() {
            this.isExportModalVisible = false;
            this.currentCSVPage = 1;
            this.rowsCSV = 0;
            this.rowsExportedCSV = 0;
            this.totalCSVPages = 0;
            this.percentage = 0;
            this.fileName = '';
            this.fetchRepAuditListCSV();
          },
          fetchRepAuditListCSV: function() {
            const params = {};
            if (this.accountId) {
                params.accountId = this.accountId
            }
            if (this.rep_mentee) {
                params.mentee = this.rep_mentee
            }
            if (this.rep_days) {
                params.days = this.rep_days;
            } else {
                params.days = '';
            }
            if (this.sortField) {
                params.sortfield = this.sortField
            }
            if (this.sortBy) {
                params.sortby = this.sortBy
            }
            params.page = this.currentCSVPage;
            params.perPage = this.perCSVPage;
            params.fileName = this.fileName;
            params.show_comments = this.show_comments;

            axios.get('/enterprise-admin/account_mentee_ratings_report_csv', {
                params: params
            })
            .then(response => {
              this.isExportModalVisible = true;
              this.currentCSVPage = response.data.page;
              this.rowsCSV = response.data.total_rows;
              this.rowsExportedCSV = response.data.total_rows_exported;
              this.totalCSVPages = response.data.total_pages;
              this.percentage = response.data.percentage;
              this.fileName = response.data.file_name;
              document.getElementById("batch-loading").style.width = this.percentage;
              if(this.currentCSVPage <= this.totalCSVPages) {
                this.fetchRepAuditListCSV();
              }
            })
            .catch(error => {

            });

        },

        showNaicsofPaginated() {
          this.currentPage = this.$refs.Pagination.currentPageValue;
          this.filterCompetency();
        },
        perPagePaginated() {
          this.currentPage = 1;
          this.$refs.Pagination.currentPageValue = 1;
          this.perPage = this.$refs.Pagination.perPageValue;
          this.filterCompetency();
        },
        sortMethod: function(field) {
            this.sortField = field;
            if(this.sortBy == 'ASC') {
                this.sortBy = 'DESC';
            }
            else {
                this.sortBy = 'ASC';
            }
            this.filterCompetency();
        },
        filterCompetency() {    
            this.loading = true; 
            
            const params = {};
            if (this.accountId) {
                params.accountId = this.accountId
            }
            if (this.rep_mentee) {
                params.mentee = this.rep_mentee
            }
            if (this.rep_days) {
                params.days = this.rep_days
            } else {
                params.days = '';
            }
            if (this.sortField) {
                params.sortfield = this.sortField
            }
            if (this.sortBy) {
                params.sortby = this.sortBy
            }
            params.page = this.currentPage;
            params.perPage = this.perPage;
            //console.log(params)
            axios.get('/enterprise-admin/account_mentee_ratings_report', {
                params: params
            })
            .then(response =>  {
                this.loading = false;           
                this.results = response.data.data;
                this.currentPage = response.data.page;
                if(this.currentPage > 1) {
                  this.sno = this.perPage * (this.currentPage - 1);
                }
                else {
                  this.sno = 0;
                }
                this.rows = response.data.total_rows;
                this.totalPages = response.data.total_pages;
            })
            .catch(function(error) {
                console.log(error);
            });
        },
        goToLocationWindow() {
            router.push('/enterprise-admin-dashboard');
        },
        closeSidebar() {
            this.isModalVisible = false;
        },
        getAccountMenteesList() {
            this.loading = true;
            axios.get('/enteprise-admin/account_mentees_list/' + this.accountId, {        
            })
            .then(response =>  {
                this.menteeLists = [];
                this.rep_mentee = 'All';
                this.menteeLists.push({
                'value': 'All',
                'text': 'All Users',
                });
                var Lists = response.data;
                for(var i=0; i<Lists.length; i++) {
                    this.menteeLists.push({
                    'value': Lists[i].value,
                    'text': Lists[i].display
                    });
                }
                const params = {};
                if (this.rep_days) {
                    params.days = this.rep_days;
                } else {
                    params.days = '';
                }
                if (this.sortField) {
                    params.sortfield = this.sortField
                }
                if (this.sortBy) {
                    params.sortby = this.sortBy
                }
                params.page = this.currentPage;
                params.perPage = this.perPage;
                params.accountId = this.accountId
                params.mentee = this.rep_mentee;
                axios.get('/enterprise-admin/account_mentee_ratings_report', {
                    params: params
                })
                .then(response =>  {           
                    this.loading = false;           
                    this.results = response.data.data;
                    this.currentPage = response.data.page;
                    if(this.currentPage > 1) {
                      this.sno = this.perPage * (this.currentPage - 1);
                    }
                    else {
                      this.sno = 0;
                    }
                    this.rows = response.data.total_rows;
                    this.totalPages = response.data.total_pages;
                })
                .catch(function(error) {
                    console.log(error);
                });
            })
            .catch(function(error) {
                console.log(error);
            });
        }
    },
    created: function () {
        this.loading = true;
        this.accountId = this.$route.params.accountId;
        this.apiUrl = process.env.API_ENDPOINT;
        axios('/enterprise-admin/getAllLinkedLocations',
        {
            method: 'GET'
        })
        .then(response => {
            var Lists = response.data.locations;
            // console.log(Lists);
            this.report_all_locations.push({
            'value': 'All',
            'text': 'All Locations',
            });
            for(var j=0; j<Lists.length; j++) {
                this.report_all_locations.push({
                'value': Lists[j].id,
                'text': Lists[j].company_name,
                });
            }
        })
        .catch(() => {
        });
        this.getAccountMenteesList();

        
    }
}
</script>

<style scoped>
.field_1 {
    width: 5%;
    padding-left: 5px;
    cursor: pointer;
}
.field_2_1 {
    width: 12%;
    padding-left: 15px;
    cursor: pointer;
}
.field_2_2 {
    width: 16%;
    padding-left: 15px;
    cursor: pointer;
}
.field_3_1 {
    width: 10%;
    padding-left: 15px;
    cursor: pointer;
}
.field_3_2 {
    width: 11%;
    padding-left: 15px;
    cursor: pointer;
}
.field_3_3 {
    width: 12%;
    padding-left: 15px;
    cursor: pointer;
}
.field_3_4 {
    width: 14%;
    padding-left: 15px;
    cursor: pointer;
}
.field_4_1, .field_5 {
    width: 12%;
    padding-left: 15px;
    cursor: pointer;
}
.field_4_2 {
    width: 15%;
    padding-left: 15px;
    cursor: pointer;
}
.field_6_1 {
    width: 9%;
    padding-left: 15px;
    cursor: pointer;
}
.field_6_2 {
    width: 11%;
    padding-left: 15px;
    cursor: pointer;
}
.field_6_3 {
    width: 13%;
    padding-left: 15px;
    cursor: pointer;
}
.field_7_1 {
    width: 7%;
    padding-left: 15px;
    cursor: pointer;
}
.field_7_2 {
    width: 10%;
    padding-left: 15px;
    cursor: pointer;
}
.field_8_1 {
    width: 10%;
    padding-left: 15px;
    cursor: pointer;
}
.field_8_2 {
    width: 12%;
    padding-left: 15px;
    cursor: pointer;
}
.field_9_1, .field_10 {
    width: 10%;
    padding-left: 15px;
    cursor: pointer;
}
.field_9_2 {
    width: 14%;
    padding-left: 15px;
    cursor: pointer;
}



.circle {
    background-color: #2EACEE;
    border-radius: 50%;
    height: 36px;
    width: 36px;
    text-align: center;
}

.circle i {
    color: #FFF;
    font-size: 24px;
    text-align: center;
    padding-top: 5px;
    padding-right: 2px;
}

.print-section {
    font-family: "proxima-nova", sans-serif;
    color: #002F42;
}

.rep_audit_bg {
    background-color: #FFF;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 10px;
}

.rep_heading {
    font-size: 24px !important;
    font-weight: normal !important;
    margin-bottom: 10px;
}

.report_heading {
    padding-top: 8px;
    padding-bottom: 8px;
    font-weight: bold;
}

.report_view {
    padding-top: 8px;
    padding-bottom: 8px;
}

.txt_break {
    word-break: break-word;
}

.table-heading-seperator {
    border-bottom: 1px solid #707070;
}

.custom_heading_hr,
.custom_hr {
    width: 100%;
    margin: 5px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.custom_heading_hr {
    border-bottom: 3px solid rgba(0, 0, 0, 0.1);
}


.filterBtn {
    display: flex;
    margin: 0 auto;
}

.cp-filter-label {
    font-weight: bold;
    padding: 0px;
    margin: 0 5px;
    vertical-align: middle;
}

.sub-heading h3 {
    font-size: 15px;
}
.report_view .field_1, .report_view .field_2_1, .report_view .field_2_2, .report_view .field_3_1, .report_view .field_3_2, .report_view .field_3_3, .report_view .field_3_4, .report_view .field_4_1, .report_view .field_4_2, .report_view .field_5, .report_view .field_6_1, .report_view .field_6_2, .report_view .field_6_3, .report_view .field_7_1, .report_view .field_7_2, .report_view .field_8_1, .report_view .field_8_2, .report_view .field_9_1, .report_view .field_9_2, .report_view .field_10 {
    cursor: default !important;
}
.btn:disabled {
    background-color: #8b8b8b;
    color: #FFF;
}
.success_msg {
  color: #68C47E; text-align: center; margin-bottom: 15px;
}
.btn-dard-grey, .btn-red {
  line-height: 30px; border-radius: 10px;  
}
.filter-btn {
    float: left; border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/rep_audit_trail.vue